import React , { useRef , useState} from 'react';
import { Form, Field } from 'react-final-form';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import { contacterService } from '../../Data/typeService_service';
import { useService } from '../../Context/ServiceContext';
import { useActif } from '../../Context/ActifContext';
import FileUploader from '../NousContacter/FileUploader.jsx'
import "../NousContacter/FileUploader.css"
export default function NousContacterDevis({setDialog}) {
    const {selectedService,service }=useService()
    const{selectedActif}=useActif()
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile && selectedFile.size <= 20 * 1024 * 1024) {
        setFile(selectedFile);
        setFileName(selectedFile.name);
      } else {
        alert('Vous avez dépassé la taille maximum autorisée : 20 Mo.');
        setFile(null);
        setFileName('');
      }
    };
   
    

const toast = useRef(null);
    const onSubmit = async (data) => {
        const ServiceId=Object.values(service).filter(item => item.libelle ===selectedService).map(item => item.id_type_service_gexpertise)
        const formData = new FormData();
        formData.append("actifId", selectedActif.id_actif_gexpertise)
        formData.append("objet", data.objet)
        formData.append("contenu", data.contenu)
        formData.append("file", file);
        contacterService(ServiceId[0], formData)
        
        .then(()=> {
      
       toast.current.show({ severity: 'success', summary: 'Succès ', detail: 'Votre demande a été envoyée avec succès  ', life: 1000 });
       setTimeout(() => {
           setDialog(false) 
         },1000);
      })
      
    
       .catch( (error)=>{

       console.error(error);

   })
     }
    const validate = (data) => {
        let errors = {};

        if (!data.objet) {
            errors.objet = 'Ce champ est obligatoire.'
        }
        if (!data.contenu) {
            errors.contenu = 'Ce champ est obligatoire.'
        }

        return errors;
    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };

    return (
        <>
        <Toast ref={toast} />
        <div className="toolBar_header">
            <Form onSubmit={onSubmit} initialValues={{ objet: `demande de devis sur le service: ${selectedService}`, contenu: ''}} validate={validate} render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="p-fluid">


                    <Field name="objet" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputText id="objet" {...input}  autoFocus  className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="objet" >Objet *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                    <Field name="contenu" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputTextarea id="Contenu" {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} autoResize />
                                <label htmlFor="Contenu" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Écrivez ici *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                     <FileUploader
                                     onFileChange={(selectedFile) => setFile(selectedFile)}
                                     label="Joindre un fichier"
                                     maxSize={20} // 20 MB
                                   />
                                         <div className='btnContact'>
                                             
                                             <Button type="submit" label="Envoyer" className="p-mt-2 send" />
                                         </div>
                     

                </form>
            )} />


        </div>
        </>
    )
}